var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleTelehealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 124,
    viewBox: "0 0 123 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#80AAC2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26891_74364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.375 58.6875C40.375 59.8477 41.2773 60.75 42.4375 60.75H57.5625C58.6797 60.75 59.625 59.8477 59.625 58.6875V47H40.375V58.6875ZM54.125 50.2656C54.125 50.0078 54.3398 49.75 54.6406 49.75H56.3594C56.6172 49.75 56.875 50.0078 56.875 50.2656V51.9844C56.875 52.2852 56.6172 52.5 56.3594 52.5H54.6406C54.3398 52.5 54.125 52.2852 54.125 51.9844V50.2656ZM54.125 55.7656C54.125 55.5078 54.3398 55.25 54.6406 55.25H56.3594C56.6172 55.25 56.875 55.5078 56.875 55.7656V57.4844C56.875 57.7852 56.6172 58 56.3594 58H54.6406C54.3398 58 54.125 57.7852 54.125 57.4844V55.7656ZM48.625 50.2656C48.625 50.0078 48.8398 49.75 49.1406 49.75H50.8594C51.1172 49.75 51.375 50.0078 51.375 50.2656V51.9844C51.375 52.2852 51.1172 52.5 50.8594 52.5H49.1406C48.8398 52.5 48.625 52.2852 48.625 51.9844V50.2656ZM48.625 55.7656C48.625 55.5078 48.8398 55.25 49.1406 55.25H50.8594C51.1172 55.25 51.375 55.5078 51.375 55.7656V57.4844C51.375 57.7852 51.1172 58 50.8594 58H49.1406C48.8398 58 48.625 57.7852 48.625 57.4844V55.7656ZM43.125 50.2656C43.125 50.0078 43.3398 49.75 43.6406 49.75H45.3594C45.6172 49.75 45.875 50.0078 45.875 50.2656V51.9844C45.875 52.2852 45.6172 52.5 45.3594 52.5H43.6406C43.3398 52.5 43.125 52.2852 43.125 51.9844V50.2656ZM43.125 55.7656C43.125 55.5078 43.3398 55.25 43.6406 55.25H45.3594C45.6172 55.25 45.875 55.5078 45.875 55.7656V57.4844C45.875 57.7852 45.6172 58 45.3594 58H43.6406C43.3398 58 43.125 57.7852 43.125 57.4844V55.7656ZM57.5625 41.5H55.5V39.4375C55.5 39.0938 55.1562 38.75 54.8125 38.75H53.4375C53.0508 38.75 52.75 39.0938 52.75 39.4375V41.5H47.25V39.4375C47.25 39.0938 46.9062 38.75 46.5625 38.75H45.1875C44.8008 38.75 44.5 39.0938 44.5 39.4375V41.5H42.4375C41.2773 41.5 40.375 42.4453 40.375 43.5625V45.625H59.625V43.5625C59.625 42.4453 58.6797 41.5 57.5625 41.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26891_74364",
    x: -22.125,
    y: -23.75,
    width: 144.25,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26891_74364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26891_74364",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTelehealth);
export default __webpack_public_path__ + "static/media/schedule-telehealth.55fd2722.svg";
export { ForwardRef as ReactComponent };